export default __webpack_public_path__ + "static/gear-3b14b7668be5cc7f5a96cff029f081d3.jpg";